import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Calendar } from "lucide-react";
import { chapterInfo, contacts } from "../data/mock";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A3161] text-[#F5F5F7] overflow-hidden">
      <div className="stars absolute inset-0 opacity-30" />
      <div className="ribbon-divider" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 rounded-full bg-[#F5F5F7] flex items-center justify-center border-2 border-[#FFFFFF]">
                <span className="font-display text-[#0A3161] text-xl font-bold">240</span>
              </div>
              <div>
                <p className="font-display text-xl font-bold">VVA Chapter 240</p>
                <p className="text-xs font-condensed uppercase tracking-widest text-[#FFFFFF]">
                  Est. 1986
                </p>
              </div>
            </div>
            <p className="text-sm text-[#F5F5F7]/70 leading-relaxed">
              A 501(c)19 service organization supporting veterans and their families in Sumner
              County, Tennessee.
            </p>
            <p className="mt-6 font-display italic text-[#FFFFFF] text-sm leading-relaxed">
              &ldquo;{chapterInfo.motto}&rdquo;
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-condensed uppercase tracking-widest text-sm text-[#FFFFFF] mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/activities", label: "Activities" },
                { to: "/veterans-park", label: "Veterans Park" },
                { to: "/membership", label: "Membership" },
                { to: "/golf-tournament", label: "Golf Tournament" },
                { to: "/fishing-tournament", label: "Fishing Tournament" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-[#F5F5F7]/80 hover:text-[#FFFFFF] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Meeting */}
          <div>
            <h4 className="font-condensed uppercase tracking-widest text-sm text-[#FFFFFF] mb-6">
              Monthly Meeting
            </h4>
            <ul className="space-y-4 text-sm text-[#F5F5F7]/80">
              <li className="flex gap-3">
                <Calendar className="w-4 h-4 mt-0.5 text-[#FFFFFF] shrink-0" />
                <span>{chapterInfo.meetingSchedule}</span>
              </li>
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FFFFFF] shrink-0" />
                <span>{chapterInfo.meetingLocation}</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-condensed uppercase tracking-widest text-sm text-[#FFFFFF] mb-6">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-[#F5F5F7]/80">
              <li className="flex gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#FFFFFF] shrink-0" />
                <a href={`tel:${contacts.chapter.phone}`} className="hover:text-[#FFFFFF]">
                  {contacts.chapter.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#FFFFFF] shrink-0" />
                <a href={`mailto:${contacts.chapter.email}`} className="hover:text-[#FFFFFF]">
                  {contacts.chapter.email}
                </a>
              </li>
              <li className="pt-3 border-t border-[#F5F5F7]/10">
                <p className="text-xs uppercase tracking-widest font-condensed text-[#FFFFFF] mb-1">
                  Flag Ceremony
                </p>
                <p>{contacts.flagCeremony.name}</p>
                <a
                  href={`tel:${contacts.flagCeremony.phone}`}
                  className="block hover:text-[#FFFFFF]"
                >
                  {contacts.flagCeremony.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F5F5F7]/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#F5F5F7]/50">
            &copy; {new Date().getFullYear()} Vietnam Veterans of America, Chapter 240. All rights
            reserved.
          </p>
          <p className="text-xs font-condensed uppercase tracking-widest text-[#FFFFFF]">
            501(c)19 · Chartered Nov 24, 1986
          </p>
        </div>
      </div>
    </footer>
  );
}
